export class AuthStorage {
  private token: Nullable<string> = null;
  private uid: number = -1;

  constructor() {
    this.token = '';
    this.uid = -1;
  }

  public setToken(token?: string | null) {
    this.token = token;
  }

  public getToken() {
    return this.token;
  }

  public setUid(uid: number) {
    this.uid = uid;
  }

  public getUid() {
    return this.uid;
  }
}

export const authStorage = new AuthStorage();
